/* eslint-disable react/no-is-mounted */
import React, { useMemo } from "react";
import {Badge, Container, Row, Col, Card, CardBody, BreadcrumbItem} from "reactstrap"
import {
    Input,
  } from "reactstrap"
import {Link} from 'react-router-dom';
import LoadingContainer from "../Utility/Helpers/LoadingContainer";
import {DIALOG_TYPE, HTTP_RESPONSE} from "../Utility/Helpers/constants";
import DialogBoxComponent from "../Utility/Helpers/DialogBoxComponent";
import "../Utility/Helpers/style.css";
import ProjectsRepository from "./Repository/project-repository";
import PaginationWrap from "../Utility/Helpers/PaginationWrap";
import ActionsFormatter from "../Utility/Helpers/ActionsFormatter";
import AuthorizationChecker from "../../security/AuthorizationChecker";
import UserProvier from "security/UserProvier";
import { withTranslation } from "react-i18next";
import TableContainerGrid from "pages/Utility/Helpers/TableContainerGrid";
class PagesProjects extends React.Component {
    /**
     *
     * @param props
     */
    constructor(props) {
        super(props);
        this.abortController = new AbortController();
       // console.log ("worker",cluster.isMaster)
        // eslint-disable-next-line react/prop-types
        this.state = {
            CORRECT_STATUS:[],
            projectStatus : {},
            items: [],
            errors: [],
            total: 0,
            entity: null, // element courant
            itemPerpage: 10,
            loading: true,
            loadingSearch: false,
            query: "",
            showConfirmDialog: false,
            companyId: UserProvier.get().companyId,
            pageSizeOptions: {
                totalSize: 0, // replace later with size(customers),
                custom: true,
                onPageChange: (page) => this.onPageChange(page),
                onSearchChange: this.handleSearchChange,
                page: 1,
                sizePerPage: 10,
                pageStartIndex: 1,
                sizePerPageList: 10,
                showTotal: true,
                onSizePerPageChange: {}
            },
            dialog: {
                show: false,
                onConfirm: () => {
                },
                handleClose: () => {
                },
                message: "",
                type: DIALOG_TYPE.ALERT,
            },
            selectedProjectsIds: [],
            unSelectableProjectsIds: []
        };
        this.onPageChange = this.onPageChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.selectRow = {mode: 'checkbox'};
        this.handleDelete = this.handleDelete.bind(this);
        this.sendToMondou = this.sendToMondou.bind(this)

        this.selectProject = this.selectProject.bind(this);
        this.selectAllProject = this.selectAllProject.bind(this);
        this.parseState = this.parseState.bind(this);
        this.assignProject = this.assignProject.bind(this);
        

        
        
    }


    //newtravble begin
   
       ;
    

    
    //end new table
    /**
     * Parses and returns the project status based on the given state ID.
     * 
     * This function looks up the project status in the component's state using the provided state ID.
     * If the state ID is found in the projectStatus object, it returns the corresponding status.
     * If the state ID is not found, it returns the default status (index 0).
     *
     * @param {number|string} stateId - The ID of the state to parse.
     * @returns {*} The project status corresponding to the given state ID, or the default status if not found.
     */
    parseState (stateId){
        //console.log("keys:",Object.keys(this.state.projectStatus))
        if( Object.keys(this.state.projectStatus).indexOf(""+stateId) >= 0){
            return this.state.projectStatus[stateId]
        }else{
            return this.state.projectStatus[0]
        }
    }
    
    componentDidMount() {
        ProjectsRepository.getStatus().then(data=>{
            console.log("Status:",data)
            this.setState((state)=>({...state, projectStatus: data, CORRECT_STATUS: data["CORRECT_STATUS"]}))
            this.findAll();
        }).catch(response=>{
            console.log("Failed loading status : ", response)
        })
    }

    componentWillUnmount() {
        // Annuler toutes les requêtes en cours
    if (this.abortController) {
        this.abortController.abort();
    }
        this.setState = (state, callback) => {
            return;
        };
    }

    /**
     * Handles page change in the pagination component.
     * Updates the component state with the new page number and triggers data fetching for the new page.
     *
     * @param {number} page - The new page number to be set.
     * @returns {void} This function doesn't return a value. It updates the component state and triggers a side effect.
     */
    onPageChange(page) {
        this.setState(
            (state) => ({
                ...state,
                loading: true,
                page: page,
            }),
            () => {
                this.findAll(page);
            }
        );
    }

    /**
     * Handles the selection or deselection of all selectable projects.
     * 
     * This function is triggered when the "select all" checkbox is clicked. It updates
     * the state to either select all selectable projects or deselect all projects,
     * depending on the checkbox state.
     *
     * @param {Object} event - The event object from the checkbox change event.
     * @param {boolean} event.target.checked - The new checked state of the "select all" checkbox.
     * 
     * @returns {void} This function doesn't return a value. It updates the component's state.
     */
    selectAllProject (event){
        let {checked} = event.target
        let selectedProjects = []

        if(checked){
            selectedProjects = this.state.items.filter((p)=>{return this.state.unSelectableProjectsIds.indexOf(p.id)==-1}).map((e)=>{return e.id})
        }
        this.setState((state)=>({...this.state, selectedProjectsIds: selectedProjects}))
    }

    /**
     * Handles the selection or deselection of a project.
     * 
     * This function updates the state to reflect whether a project is selected or not.
     * If the project is unselectable, it triggers an error. Otherwise, it toggles the 
     * project's selection status in the component's state.
     *
     * @param {number|string} id - The unique identifier of the project to be selected or deselected.
     * @param {Event} event - The event object from the selection action (not used directly in the function).
     * @returns {void} This function doesn't return a value. It updates the component's state.
     */
    selectProject(id, event) {
        if (this.state.unSelectableProjectsIds.indexOf(id) >= 0) {
            this.catchError({
                status: HTTP_RESPONSE.HTTP_UNAUTHORIZED,
                data: {
                    error: {
                        message: "{\"message\":\"PROJECT_UNMODIFIABLE\",\"name\":\"PROJECT_AT_INCOMPATIBLE_STATE\"}"
                    }
                }
            })
            return
        }
        //let {checked} = event.target
        let checked = (this.state.selectedProjectsIds.indexOf(id) == -1)
        let selectedProjects = this.state.selectedProjectsIds

        if (checked) {
            selectedProjects.push(id)
        } else {
            selectedProjects = selectedProjects.filter((i) => { return i != id })
        }
        this.setState((state) => ({ ...state, selectedProjectsIds: selectedProjects }))
    }

    /**
     * Handles the delete action for a project element.
     * 
     * This function prepares the component's state for a deletion confirmation dialog.
     * It sets up the dialog with the appropriate callbacks and type, and then displays the dialog.
     *
     * @param {Event} e - The event object triggered by the delete action.
     * @param {Object} elt - The project element to be deleted.
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers a side effect.
     */
    handleDelete(e, elt) {
        e.preventDefault();
        this.setState(
            (state) => ({
                ...state,
                entity: elt,
                dialog: {
                    ...state.dialog,
                    onConfirm: () => this.performDelete(),
                    handleClose: () => this.closeDialogModal(),
                    type: DIALOG_TYPE.CONFIRM_DELETION
                }
            }),
            () => {
                this.toggleDialogModal();
            }
        );
    }

    handleSearchChange(query) {}

    /**
     * Fetches and updates the list of projects based on the current page, items per page, and search query.
     * This function updates the component's state with the fetched data and handles pagination options.
     *
     * @param {number} [page=1] - The page number to fetch. Defaults to 1 if not provided.
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers side effects.
     */
    findAll(page = 1) {
        ProjectsRepository.findAll(page, this.state.itemPerpage, this.state.query).then(data => {
            this.setState(
                (state) => ({
                    ...state,
                    items: data.items,
                    unSelectableProjectsIds:  data.items.filter((p)=>this.state.CORRECT_STATUS.indexOf(p.statusId)<0).map(p=>p.id),
                    total: data.totalCount,
                    pageSizeOptions: {
                        sizePerPage: this.state.itemPerpage,
                        totalSize: 10, // replace later with size(customers),
                        custom: true,
                        onPageChange: (page) => this.onPageChange(page),
                        onSearchChange: this.handleSearchChange
                    },
                }),
                () => {
                    this.setState((state) => ({...state, loading: false, loadingSearch: false}));
                }
            );
        }).catch(response => {
            this.catchError(response);
        });
    }

    /**
     * Sends selected projects to Mondou.
     * 
     * This function updates the component's state to show loading, then sends the
     * selected project IDs to Mondou using the ProjectsRepository. After successful
     * sending, it clears the selection and refreshes the project list.
     * 
     * @function
     * @name sendToMondou
     * @memberof PagesProjects
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers side effects.
     * @throws {Error} Catches and handles any errors that occur during the process.
     */
    sendToMondou(){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.sendToMondo(this.state.selectedProjectsIds).then(()=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))
                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Sends selected projects to RenPet.
     * 
     * This function updates the component's state to show loading, then sends the
     * selected project IDs to RenPet using the ProjectsRepository. After successful
     * sending, it clears the selection and refreshes the project list.
     * 
     * @function
     * @name sendToRenPet
     * @memberof PagesProjects
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers side effects.
     * @throws {Error} Catches and handles any errors that occur during the process.
     */
    sendToRenPet(){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.sendToRenPet(this.state.selectedProjectsIds).then(()=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))
                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Sends selected projects to DM (Decision Maker).
     * 
     * This function updates the component's state to show loading, then sends the
     * selected project IDs to DM using the ProjectsRepository. After successful
     * sending, it clears the selection and refreshes the project list.
     * 
     * @function
     * @name sendToDM
     * @memberof PagesProjects
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers side effects.
     * @throws {Error} Catches and handles any errors that occur during the process.
     */
    sendToDM(){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.sendToDM(this.state.selectedProjectsIds).then(()=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))
                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Sends selected projects to the Ecom system.
     * 
     * This function updates the component's state to show loading, then sends the
     * selected project IDs to Ecom using the ProjectsRepository. After successful
     * sending, it clears the selection and refreshes the project list.
     * 
     * @function
     * @name sendToEcom
     * @memberof PagesProjects
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers side effects.
     * @throws {Error} Catches and handles any errors that occur during the process.
     */
    sendToEcom(){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.sendToEcom(this.state.selectedProjectsIds).then(()=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))
                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Assigns a project to the current user.
     * 
     * This function updates the component's state to show loading, then calls the
     * ProjectsRepository to assign the specified project. After successful assignment,
     * it refreshes the list of projects. If an error occurs during the process, it
     * catches and handles the error.
     *
     * @param {number|string} projectId - The unique identifier of the project to be assigned.
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers side effects.
     */
    assignProject(projectId){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.assignProject(projectId).then(()=>{
                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Sends selected projects back to the vendor.
     * 
     * This function updates the component's state to show loading, then sends the
     * selected project IDs back to the vendor using the ProjectsRepository. After 
     * successful sending, it clears the selection and refreshes the project list.
     * 
     * @function
     * @name sendBackToVendor
     * @memberof PagesProjects
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers side effects.
     * @throws {Error} Catches and handles any errors that occur during the process.
     */
    sendBackToVendor(){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.sendToVendor(this.state.selectedProjectsIds).then(()=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))
                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Sends selected projects back to the buyer.
     * 
     * This function updates the component's state to show loading, then sends the
     * selected project IDs back to the buyer using the ProjectsRepository. After 
     * successful sending, it clears the selection and refreshes the project list.
     * If an error occurs during the process, it catches and handles the error.
     * 
     * @function
     * @name sendBackToBuyer
     * @memberof PagesProjects
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers side effects.
     * @throws {Error} Catches and handles any errors that occur during the process.
     */
    sendBackToBuyer(){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.sendToBuyer(this.state.selectedProjectsIds).then(()=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))
                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Confirms SAP creation for selected projects.
     * 
     * This function updates the component's state to show loading, then confirms
     * SAP creation for the selected project IDs using the ProjectsRepository.
     * After successful confirmation, it clears the selection and refreshes the project list.
     * If an error occurs during the process, it catches and handles the error.
     * 
     * @function
     * @name confirmSapCreation
     * @memberof PagesProjects
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers side effects.
     * @throws {Error} Catches and handles any errors that occur during the process.
     */
    confirmSapCreation(){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.confirmSapCreation(this.state.selectedProjectsIds).then(()=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))
                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Exports selected projects for SAP.
     * 
     * This function updates the component's state to show loading, then exports
     * the selected project IDs for SAP using the ProjectsRepository. After successful
     * export, it creates a downloadable CSV file with the exported data, clears the
     * selection, and refreshes the project list. If an error occurs during the process,
     * it catches and handles the error.
     * 
     * @function
     * @name exportForSAP
     * @memberof PagesProjects
     * @returns {void} This function doesn't return a value. It updates the component's state, triggers a file download, and refreshes the project list.
     * @throws {Error} Catches and handles any errors that occur during the export process.
     */
    exportForSAP(){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.exportForSAP(this.state.selectedProjectsIds).then((result)=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))

                    var blob=new Blob([result.data]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    link.download="project_exported_sap_"+(new Date()).toISOString() + ".csv";
                    link.click();

                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Exports selected projects to Microsoft.
     * 
     * This function updates the component's state to show loading, then exports
     * the selected project IDs to Microsoft using the ProjectsRepository. After 
     * successful export, it creates a downloadable CSV file with the exported data,
     * clears the selection, and refreshes the project list.
     * 
     * @function
     * @name exportToMicrosoft
     * @memberof PagesProjects
     * @returns {void} This function doesn't return a value. It updates the component's state, triggers a file download, and refreshes the project list.
     * @throws {Error} Catches and handles any errors that occur during the export process.
     */
    exportToMicrosoft(){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.exportToMicrosoft(this.state.selectedProjectsIds).then((result)=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))

                    var blob=new Blob([result.data]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    link.download="project_exported_to_microsoft_"+(new Date()).toISOString() + ".csv";
                    link.click();

                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Sends selected projects back to modification status for the buyer.
     * 
     * This function updates the component's state to show loading, then sends the
     * selected project IDs back to modification status using the ProjectsRepository.
     * After successful modification, it clears the selection and refreshes the project list.
     * If an error occurs during the process, it catches and handles the error.
     * 
     * @function
     * @name buyerBackToModification
     * @memberof PagesProjects
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers side effects.
     * @throws {Error} Catches and handles any errors that occur during the process.
     */
    buyerBackToModification(){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.backToModification(this.state.selectedProjectsIds).then(()=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))
                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Sends selected projects back to modification status.
     * 
     * This function updates the component's state to show loading, then sends the
     * selected project IDs back to modification status using the ProjectsRepository.
     * After successful modification, it clears the selection and refreshes the project list.
     * If an error occurs during the process, it catches and handles the error.
     * 
     * @function
     * @name backToModification
     * @memberof PagesProjects
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers side effects.
     * @throws {Error} Catches and handles any errors that occur during the process.
     */
    backToModification(){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.backToModification(this.state.selectedProjectsIds).then(()=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))
                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Exports selected projects to Ecom and optionally finishes the project.
     * 
     * This function updates the component's state to show loading, then exports
     * the selected project IDs to Ecom using the ProjectsRepository. If not finishing
     * the project, it creates a downloadable CSV file with the exported data.
     * After the export, it clears the selection and refreshes the project list.
     * 
     * @function
     * @name exportToEcom
     * @param {boolean} [finishProject=false] - If true, marks the project as finished. If false, only exports the data.
     * @returns {void} This function doesn't return a value. It updates the component's state, potentially triggers a file download, and refreshes the project list.
     * @throws {Error} Catches and handles any errors that occur during the export process.
     */
    exportToEcom(finishProject=false){
        this.setState(
            (state) => ({ ...state, loading: true}),
            () => {
                ProjectsRepository.exportToEcom(this.state.selectedProjectsIds, finishProject).then((result)=>{
                    this.setState((state) =>({...this.state, selectedProjectsIds: []}))

                    if(!finishProject){
                        var blob=new Blob([result.data]);
                        var link=document.createElement('a');
                        link.href=window.URL.createObjectURL(blob);
                        link.download="project_ecom_exported_"+(new Date()).toISOString() + ".csv";
                        link.click();
                    }

                    this.findAll()
                }).catch(response => {
                    this.catchError(response);
                });
            }
        );
    }

    /**
     * Handles changes in the table's state, such as pagination, sorting, filtering, and searching.
     * 
     * @param {string} type - The type of change that occurred in the table. Can be 'pagination', 'sort', 'filter', or 'search'.
     * @param {Object} changeParams - An object containing parameters related to the change.
     * @param {string} changeParams.searchText - The current search text when the change type is 'search'.
     * @param {number} changeParams.page - The current page number when the change type is 'pagination'.
     * @param {number} changeParams.sizePerPage - The number of items per page when the change type is 'pagination'.
     * @param {Object} changeParams.filters - The current filter settings when the change type is 'filter'.
     * @param {string} changeParams.sortField - The field being sorted when the change type is 'sort'.
     * @param {string} changeParams.sortOrder - The order of sorting (asc/desc) when the change type is 'sort'.
     * @param {Object} changeParams.cellEdit - Information about cell editing when applicable.
     * @returns {void} This function doesn't return a value. It updates the component's state and triggers a search when necessary.
     */
    handleTableChange(type, {searchText, page, sizePerPage, filters, sortField, sortOrder, cellEdit}) {
        if (type === 'pagination') {
        } else if (type === 'sort') {

        } else if (type === 'filter') {

        } else if (type === 'search') {
            this.setState(
                (state) => ({
                    ...state,
                    query: searchText
                }),
                () => {
                    this.findAll();
                }
            );
        }
    }

    toggleDialogModal = () => {
        this.setState((state) => ({
            ...state,
            loading: false,
            dialog: {...state.dialog, show: !state.show}
        }));
    }

    closeDialogModal = () => {
        this.setState((state) => ({
            ...state,
            loading: false,
            dialog: {...state.dialog, show: false}
        }));
    }

    performDelete = () => {
        if (this.state.entity.id) {
            this.setState(
                (state) => ({
                    ...state,
                    loading: true,
                }),
                () => {
                    const idToRemove = this.state.entity.id;
                    ProjectsRepository.remove(this.state.entity.id).then(data => {
                        console.log(data);
                        this.setState((state) => ({
                            ...state,
                            loading: false,
                            id: null,
                            total: state.total - 1,
                            items: state.items.filter(elt => elt.id !== idToRemove)
                        }));
                        this.closeDialogModal();
                        this.onAllDoneSuccessfully();
                    }).catch(response => {
                        console.log(response)
                        this.catchError(response);
                       // this.closeDialogModal();
                    });
                }
            );
        }
    }

    onAllDoneSuccessfully = ()=>{
        const dialog = {
            ...this.state.dialog,
            show: true,
            handleClose: () => this.closeDialogModal(),
            type: DIALOG_TYPE.SUCCESS,
            message: this.props.t("SUCCESSFULLY_DELETED")
        }
        this.setState((state) => ({
            ...state,
            dialog: dialog,
        }));
    }
    catchError = (response) => {
        const dialog = {
            ...this.state.dialog,
            show: true,
            onConfirm: () => this.closeDialogModal(),
            handleClose: () => this.closeDialogModal(),
            type: DIALOG_TYPE.ALERT,
            message: ""
        }
        switch (response.status) {
            case HTTP_RESPONSE.HTTP_BAD_REQUEST: {
                dialog.type = DIALOG_TYPE.ALERT;
                break;
            }
            case HTTP_RESPONSE.HTTP_NOT_FOUND: {
                dialog.type = DIALOG_TYPE.ALERT;
                if (response.data.message) {
                    dialog.message = response.data.message;
                }else{
                    dialog.message = response.data.error.message;
                }
                break;
            }
            case HTTP_RESPONSE.HTTP_NOT_ACCEPTABLE : {
                dialog.type = DIALOG_TYPE.NOT_ACCEPTABLE
                dialog.message = response.data.error.message
                break;
            }
            case HTTP_RESPONSE.HTTP_UNAUTHORIZED: {
              
                dialog.type = DIALOG_TYPE.UNAUTHORIZED;
                try {
                    const err = JSON.parse(response.data.error.message)
                    console.log("Error:",err)
                    dialog.message = this.props.t(err.message) + ( err.name ?  "->" + err.name : "")
                    //adding log to message
                    /*if(err.logs){
                        //loop trough log and slpit message with ; separator to display each line in a new line the first line is the name
                       for (let index = 0; index < err.logs.length; index++) {
                           const element = err.logs[index];
                           dialog.message += "<br> " + element.name + "<br>"
                           dialog.message += "\r\n" + element.message.split(";").join("\r\n")
                       } */
                      //  dialog.message += "<br/>" + err.logs.message.split(";").join("<br/>")
                    //}
                }catch(e){
                    dialog.message = this.props.t(err.message ? err.message : "")
                }
                break;
            }
            case HTTP_RESPONSE.HTTP_INTERNAL_SERVER_ERROR: {
                if (response.data.message) {
                    dialog.message = response.data.message;
                }else{
                    dialog.message = response.data.error.message;
                }
                dialog.type = DIALOG_TYPE.SERVER_ERROR;
                break;
            }
            default:
        }
        this.setState((state) => ({
            ...state,
            dialog: dialog,
        }));
    }

    /**
     *  Methode appelée quand la valeur d'un champ de formulaire change
     *
     * @param target
     */
    handleFormInputChange = ({target}) => {
        const {name, value} = target;
        this.setState(
            (state) => ({
                ...state,
                [name]: value,
                loadingSearch: true
            }), () => {
                this.findAll();
            }
        );
    };

    handleOnPagePerPageChange = (p) => {
        this.setState(
            (state) => ({
                ...state,
                itemPerpage: p,
                page: 1,
                loading: true,
                pageSizeOptions: {
                    ...state.pageSizeOptions,
                    sizePerPage: p,
                    page: 1,
                }
            }),
            () => {
                this.setState(
                    (state) => ({
                        ...state,
                        loading: true
                    }), () => { 
                        this.findAll();
                    }
                );
            }
        );
    }

    render() {
        return <>
            <div className="page-content">
                    <title>Projects</title>
                <Container fluid={true}>
                    <LoadingContainer loading={this.state.loading}>
                        <Card>
                            <CardBody>
                                <div className="mb-4">
                                    <Row>
                                        <Col xs="12">
                                            <div className="page-title-box justify-content-between">
                                                <div className="">
                                                    <ol className="breadcrumb m-0">
                                                        <BreadcrumbItem>.</BreadcrumbItem>
                                                        <BreadcrumbItem>
                                                            <Link to="#">{this.props.t("PROJECTS")}</Link>
                                                        </BreadcrumbItem>
                                                    </ol>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col md="8" className="d-flex gap-2 align-items-center">
                                            {AuthorizationChecker.isGranted(["VENDOR_CREATE_PROJECT"]) &&  <Link className="btn btn-primary" to="/pages-projects/add"> {(this.props.t("ADD_NEW_PROJECT"))}</Link>}
                                            {AuthorizationChecker.isGranted(["VENDOR_SEND_TO_MONDOU"]) &&  <button className="btn btn-primary" disabled={this.state.selectedProjectsIds.length==0} onClick={()=>{this.sendToMondou()}}>{(this.props.t("SEND_TO_MONDOU"))}</button>}
                                            {AuthorizationChecker.isGranted(["VENDOR_SEND_TO_REN_PET"]) &&  <button className="btn btn-primary" disabled={this.state.selectedProjectsIds.length==0} onClick={()=>{this.sendToRenPet()}}>{(this.props.t("VENDOR_SEND_TO_REN_PET"))}</button>}

                                            {AuthorizationChecker.isGranted(["BUYER_EDIT_PROJECT"]) &&  <button className="btn btn-primary"  disabled={this.state.selectedProjectsIds.length==0} onClick={()=>{this.sendBackToVendor()}}>{(this.props.t("SEND_BACK_TO_VENDOR"))} </button>}

                                            {AuthorizationChecker.isGranted(["BUYER_SENT_TO_DM"]) &&  <button className="btn btn-primary" onClick={()=>{this.sendToDM()}} disabled={this.state.selectedProjectsIds.length==0}>{(this.props.t("SEND_TO_DM"))} </button>}

                                            { ( AuthorizationChecker.isGranted(["MD_EDIT_PROJECT"]) || AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"]) ) &&  <button className="btn btn-primary" disabled={this.state.selectedProjectsIds.length==0} onClick={()=>{this.sendBackToBuyer()}}>{(this.props.t("SEND_BACK_TO_PURCHASER"))}</button>}

                                            {AuthorizationChecker.isGranted(["MD_EXPORT_FOR_SAP"]) &&  <button className="btn btn-primary"  onClick={()=>{this.exportForSAP()}} disabled={this.state.selectedProjectsIds.length==0}>{(this.props.t("EXPORT_SAP"))} </button>}

                                            {AuthorizationChecker.isGranted(["BUYER_EXPORT_TO_MICROSOFT"]) &&  <button className="btn btn-primary"  onClick={()=>{this.exportToMicrosoft()}} disabled={this.state.selectedProjectsIds.length==0}>{(this.props.t("BUYER_EXPORT_TO_MICROSOFT"))} </button>}

                                            {AuthorizationChecker.isGranted(["BUYER_EXPORT_TO_MICROSOFT"]) && this.state.companyId==2  && <button className="btn btn-primary"  onClick={()=>{this.buyerBackToModification()}} disabled={this.state.selectedProjectsIds.length==0}>{(this.props.t("BACK_TO_MODIFICATION"))} </button>}

                                            {AuthorizationChecker.isGranted(["MD_CONFIRM_SAP"]) &&  <button className="btn btn-primary"  onClick={()=>{this.backToModification()}} disabled={this.state.selectedProjectsIds.length==0}>{(this.props.t("BACK_TO_MODIFICATION"))} </button>}

                                            {AuthorizationChecker.isGranted(["MD_CONFIRM_SAP"]) &&  <button className="btn btn-primary"  onClick={()=>{this.confirmSapCreation()}} disabled={this.state.selectedProjectsIds.length==0}>{(this.props.t("CONFIRM_CREATION_SAP"))} </button>}

                                            { AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"]) &&  <button className="btn btn-primary" onClick={()=>{this.exportToEcom()}} disabled={this.state.selectedProjectsIds.length==0}>{(this.props.t("EXPORT_FOR_ECOM"))} </button> } 

                                            {AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"]) &&  <button className="btn btn-primary" onClick={()=>{this.exportToEcom(true)}} disabled={this.state.selectedProjectsIds.length==0}>{(this.props.t("END_PROJECT"))} </button>}

                                            { AuthorizationChecker.isGranted(["BUYER_EDIT_PROJECT"]) &&  <button className="btn btn-primary" onClick={()=>{this.sendToEcom()}}  disabled={this.state.selectedProjectsIds.length==0}>{(this.props.t("SEND_TO_ECOM"))}</button>}

                                        </Col>
                                        <Col md="4">
                                            <div className="search-box me-2 mb-2 d-inline-block float-end">
                                                <form className="search-box d-inline-block">
                                                    <div className="position-relative">
                                                        <label htmlFor="search-bar" className="search-label">
                                                            <span id="search-bar-label" className="sr-only">{this.props.t("FIND_IN_TABLE")}</span>
                                                            <input
                                                                id="search-bar"
                                                                type="text"
                                                                name="query"
                                                                className="form-control "
                                                                placeholder={this.props.t("SEARCH")}
                                                                onChange={(e) => this.handleFormInputChange(e)}
                                                                value={this.state.query}/>
                                                        </label>
                                                        <i className="bx bx-search-alt search-icon"/>
                                                    </div>
                                                </form>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <PaginationWrap
                                    page={this.state.page}
                                    paginationProps={this.state.pageSizeOptions}
                                    handleOnPagePerPageChange={(p) => this.handleOnPagePerPageChange(p)}
                                    itemPerpage={this.state.itemPerpage}
                                    onPageChange={(p) => this.onPageChange(p)}
                                    totalItems={this.state.total}
                                />
                                <LoadingContainer loading={this.state.loadingSearch}>
                                   
                                    <Row>
                                        <Col xl="12">
                                            <div className="table-responsive">
                                                <div className="react-bootstrap-table">
                                                    <table
                                                        className="table table align-middle table-nowrap">
                                                        <thead className="thead-light">
                                                        <tr>
                                                            <th tabIndex="0">
                                                                 <Input type="checkbox" onChange={(e)=>{this.selectAllProject(e)}}/>
                                                            </th>
                                                            <th tabIndex="0"/>
                                                            <th tabIndex="0">{this.props.t("VENDOR")}</th>
                                                            {/*<th tabIndex="0">{this.props.t("PROJECT_ID")}</th>*/}
                                                            <th tabIndex="0">{this.props.t("PROJECT_NAME")}</th>
                                                            { this.state.companyId!=2 && (<th tabIndex="0">{this.props.t("LEVEL_1")} </th>)}
                                                            <th tabIndex="0">{this.props.t("STATUS")}</th>
                                                            {   (   AuthorizationChecker.isGranted(["BUYER_READ_PROJECT"]) || 
                                                                    AuthorizationChecker.isGranted(["MD_READ_PROJECT"]) || 
                                                                    AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"])
                                                                ) &&
                                                                (<th tabIndex="0">{this.props.t("PURCHASER")}</th>)
                                                            }
                                                            {   (   AuthorizationChecker.isGranted(["BUYER_READ_PROJECT"]) || 
                                                                    AuthorizationChecker.isGranted(["MD_READ_PROJECT"]) || 
                                                                    AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"])
                                                                ) &&
                                                                (<th tabIndex="0">{this.props.t("DM")}</th>)
                                                            }
                                                            
                                                            <th tabIndex="0">{this.props.t("LAST_COMMENT")} </th>
                                                            { ( AuthorizationChecker.isGranted(["BUYER_EDIT_PROJECT"])  || 
                                                                AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"])
                                                              )&&
                                                                (
                                                                    <th tabIndex="0">{this.props.t("SELF_ASSIGN")}</th>
                                                                )
                                                            }
                                                            { AuthorizationChecker.isGranted(["MD_EDIT_PROJECT"]) &&
                                                                (
                                                                    <th tabIndex="0">{this.props.t("SELF_ASSIGN")}</th>
                                                                )
                                                            }
                                                            <th tabIndex="0"> {this.props.t("ASSOCIATED_PRODUCTS")}</th> 
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.items.length > 0 && this.state.items.map((item, index) =>
                                                            <tr key={index}>
                                                                <td> <Input type="checkbox" onClick={(e)=>{this.selectProject(item.id,e)}} onChange={()=>{}} checked={this.state.selectedProjectsIds.indexOf(item.id)>=0}/> </td>
                                                                <td>
                                                                    <ActionsFormatter
                                                                        editRole={
                                                                            AuthorizationChecker.isGranted(["VENDOR_READ_PROJECT"]) ? "VENDOR_EDIT_PROJECT" :
                                                                            AuthorizationChecker.isGranted(["BUYER_READ_PROJECT"]) ? "BUYER_EDIT_PROJECT" :
                                                                            AuthorizationChecker.isGranted(["MD_READ_PROJECT"]) ? "MD_EDIT_PROJECT" : 
                                                                            AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"]) ? "ECOM_EDIT_PROJECT" : 
                                                                            ""
                                                                        }
                                                                        enableRemove = {
                                                                            AuthorizationChecker.isGranted(["VENDOR_EDIT_PROJECT"]) ? (this.state.CORRECT_STATUS.indexOf(item.statusId) >=0) :
                                                                            AuthorizationChecker.isGranted(["BUYER_EDIT_PROJECT"]) ?  ( (this.state.CORRECT_STATUS.indexOf(item.statusId) >=0) && item.purchaserId==UserProvier.get().id) : true
                                                                        }
                                                                        item={item}
                                                                        enableEdit={
                                                                            AuthorizationChecker.isGranted(["VENDOR_READ_PROJECT"]) ? (this.state.CORRECT_STATUS.indexOf(item.statusId) >=0) :
                                                                            AuthorizationChecker.isGranted(["BUYER_READ_PROJECT"]) ?  ( (this.state.CORRECT_STATUS.indexOf(item.statusId) >=0) && item.purchaserId==UserProvier.get().id) :
                                                                            AuthorizationChecker.isGranted(["MD_READ_PROJECT"]) ?  ( (this.state.CORRECT_STATUS.indexOf(item.statusId) >=0) && item.dmId==UserProvier.get().id) :
                                                                            AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"]) ?  ( (this.state.CORRECT_STATUS.indexOf(item.statusId) >=0) && item.ecommId==UserProvier.get().id) : true
                                                                        }
                                                                        onDelete={(event, elt) => this.handleDelete(event, elt)}/>
                                                                </td>
                                                                <td>{item.vendorName}</td>
                                                                {/*<td>{item.id}</td>*/}
                                                                <td>{item.name}</td>
                                                                { this.state.companyId!=2 && ( <td>{item.niveau1 ? item.niveau1.description : ""}</td>)}
                                                                <td>
                                                                    <Badge className={"bg-primary"}>
                                                                        { this.parseState(item.statusId)}
                                                                    </Badge>
                                                                </td>
                                                                {   (   AuthorizationChecker.isGranted(["BUYER_READ_PROJECT"]) || 
                                                                        AuthorizationChecker.isGranted(["MD_READ_PROJECT"]) || 
                                                                        AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"])
                                                                    ) &&
                                                                    (<td> {item.purchaserId ? item.purchaserName: ""}</td>)
                                                                }
                                                                {   (   
                                                                        AuthorizationChecker.isGranted(["BUYER_READ_PROJECT"]) || 
                                                                        AuthorizationChecker.isGranted(["MD_READ_PROJECT"]) || 
                                                                        AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"])
                                                                    ) &&
                                                                    (<td> {item.dmId ? item.dmName : ""}</td>)
                                                                }
                                                               
                                                                <td>{
                                                                        (item.lastComment.comments && item.lastComment.isPrivate == 0) && 
                                                                            (
                                                                                <div className="flex-grow-1">
                                                                                    <p className="text-muted mb-0">
                                                                                        <i className="mdi mdi-calendar me-1">  </i>
                                                                                        {item.lastComment.createdAt}
                                                                                        </p>
                                                                                        <h5 className="font-size-13 mb-1">{item.lastComment.user.firstname} {item.lastComment.user.lastname}</h5>
                                                                                            <p className="text-muted mb-1  ms-3"><span dangerouslySetInnerHTML={{ __html: item.lastComment.comments }} /></p>
                                                                                
                                                                                </div>
                                                                            ) 
                                                                    }

                                                                    {  
                                                                        ((item.lastComment.comments && item.lastComment.isPrivate == 1) &&
                                                                        (
                                                                            AuthorizationChecker.isGranted(["BUYER_READ_PROJECT"]) || 
                                                                            AuthorizationChecker.isGranted(["MD_READ_PROJECT"]) || 
                                                                            AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"])  
                                                                        )) &&
                                                                                
                                                                            (
                                                                                <div className="flex-grow-1">
                                                                                <p className="text-muted mb-0">
                                                                                  <i className="mdi mdi-calendar me-1">  </i>
                                                                                  {item.lastComment.createdAt + " "}{item.lastComment.isPrivate ? (<span className="badge rounded-pill bg-danger">
                                                                                                {this.props.t("_PRIVATE_")}
                                                                                              </span>):""} </p>
                                                                                <h5 className="font-size-13 mb-1">{item.lastComment.user.firstname} {item.lastComment.user.lastname}</h5>
                                                                                <p className="text-muted mb-1  ms-3"><span dangerouslySetInnerHTML={{ __html: item.lastComment.comments }} /></p>
                                                                                
                                                                              </div>
                                                                            )
                                                                    }
                                                                </td>

                                                                { AuthorizationChecker.isGranted(["BUYER_EDIT_PROJECT"]) &&
                                                                    (
                                                                        <td> 
                                                                            { !(item.purchaserId) ? (
                                                                                    <a style={{marginLeft: "15px"}} className="btn" href="#" onClick={(event) => this.assignProject(item.id)}>
                                                                                        <i className='bx bxs-hand-up action-icon'></i>
                                                                                    </a> 
                                                                                ) :
                                                                                this.props.t("ASSIGNED")
                                                                            }
                                                                        </td>
                                                                    )
                                                                }

                                                                { AuthorizationChecker.isGranted(["MD_EDIT_PROJECT"]) &&
                                                                    (
                                                                        <td> 
                                                                            { !(item.dmId) ? (
                                                                                    <a style={{marginLeft: "15px"}} className="btn" href="#" onClick={(event) => this.assignProject(item.id)}>
                                                                                        <i className='bx bxs-hand-up action-icon'></i>
                                                                                    </a> 
                                                                                ) :
                                                                                this.props.t("ASSIGNED")
                                                                            }
                                                                        </td>
                                                                    )
                                                                }

                                                                { AuthorizationChecker.isGranted(["ECOM_READ_PROJECT"]) &&
                                                                    (
                                                                        <td> 
                                                                            { !(item.ecommId) ? (
                                                                                    <a style={{marginLeft: "15px"}} className="btn" href="#" onClick={(event) => this.assignProject(item.id)}>
                                                                                        <i className='bx bxs-hand-up action-icon'></i>
                                                                                    </a> 
                                                                                ) :
                                                                                this.props.t("ASSIGNED")
                                                                            }
                                                                        </td>
                                                                    )
                                                                }
                                                                <td>
                                                                    <Link className="btn" to={ '/pages-projects/' + item.id}><i className="bx bxs-show action-icon"/></Link>
                                                                </td>
                                                            </tr>)}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </LoadingContainer>
                                <PaginationWrap
                                    page={this.state.page}
                                    paginationProps={this.state.pageSizeOptions}
                                    handleOnPagePerPageChange={(p) => this.handleOnPagePerPageChange(p)}
                                    itemPerpage={this.state.itemPerpage}
                                    onPageChange={(p) => this.onPageChange(p)}
                                    totalItems={this.state.total}
                                />
                            </CardBody>
                        </Card>
                    </LoadingContainer>
                </Container>
            </div>
            <DialogBoxComponent
                handleClose={() => this.closeDialogModal()}
                handleConfirm={() => this.state.dialog.onConfirm()}
                show={this.state.dialog.show}
                type={this.state.dialog.type}
                message={this.state.dialog.message}
            />
        </>;
    }
}

export default withTranslation()(PagesProjects)
